/*
  Function for managing time
*/
export function useTimeManagement() {
  // Convert HH:mm to minutes since midnight
  const timeToMinutes = (time) => {
    if (!time) return null;
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  };

  // Convert minutes since midnight to HH:mm
  const minutesToTime = (minutes) => {
    if (!minutes && minutes !== 0) return "";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  };

  // Add minutes to a time string (HH:mm)
  const addMinutesToTime = (time, minutesToAdd) => {
    if (!time) return "";
    const totalMinutes = timeToMinutes(time) + minutesToAdd;
    return minutesToTime(totalMinutes);
  };

  // Subtract specific minutes from time
  const subtractMinutesFromTime = (time, minutesToSubtract) => {
    return addMinutesToTime(time, -minutesToSubtract);
  };

  // Get today's date in YYYY-MM-DD format
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  // Format duration in minutes to "HH:mm" format
  const formatDuration = (minutes) => {
    if (!minutes && minutes !== 0) return "";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}:${String(mins).padStart(2, "0")}`;
  };

  const getTimeDifferenceInMinutes = (time1, time2) => {
    const minutes1 = timeToMinutes(time1);
    const minutes2 = timeToMinutes(time2);
    return minutes2 - minutes1;
  };

  // Convert seconds to HH:mm format
  const secondsToHours = (seconds) => {
    if (!seconds && seconds !== 0) return "";

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  return {
    timeToMinutes,
    minutesToTime,
    addMinutesToTime,
    subtractMinutesFromTime,
    getTodayDate,
    formatDuration,
    getTimeDifferenceInMinutes,
    secondsToHours,
  };
}
